<section class="usuario-container">
  <!-- Perfil del usuario -->
  <div class="user-profile">
    <div class="avatar-wrapper">
      <app-decal [decal]="(tema$ | async)?.payload?.decalAvatar" anchor="cover">
        @if (usuario?.datosPersonales?.foto) {
          <img
            src="{{ usuario.datosPersonales.foto }}"
            alt="foto"
            class="user-photo"
          />
          @if (helper.esNavidad()) {
            <div class="avatar-frame"></div>
          }
        } @else {
          <div class="user-avatar">
            {{ iniciales }}
          </div>
          @if (helper.esNavidad()) {
            <div class="avatar-frame"></div>
          }
        }
      </app-decal>
      <div class="status-indicator"></div>
    </div>

    <div class="user-info">
      <span class="user-name">{{ usuario?.usuario | titlecase }}</span>
      <span class="user-role">
        @if (permisosEntidadesService.permisoElegido?.roles?.length) {
          {{ permisosEntidadesService.permisoElegido.roles[0] }}
        }
      </span>
    </div>
  </div>

  <!-- Selector de permisos -->
  <div class="permission-section">
    <span class="section-label">Trabajando como</span>

    @if (puedeCambiarPermiso()) {
      <ng-select
        [items]="permisosUsuario"
        [(ngModel)]="permisosEntidadesService.permisoElegido"
        bindLabel="nombre"
        class="permiso-selector"
        (change)="cambiarPermisos($event)"
        appendTo="body"
        [clearable]="false"
        [dropdownPosition]="'auto'"
        style="margin: 0"
      >
        <!-- Lo seleccionado -->
        <ng-template ng-label-tmp let-item="item">
          <div class="permiso-selected">
            <mat-icon class="permiso-icon" color="primary">business</mat-icon>
            <div class="permiso-info">
              <span class="permiso-cliente">{{ item.cliente?.nombre }}</span>
              <span class="permiso-nivel-badge" [attr.data-nivel]="item.nivel">
                {{ item.nivel }}
              </span>
            </div>
          </div>
        </ng-template>

        <!-- El panel de opciones -->
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <div class="permiso-option">
            <div class="permiso-header">
              <div class="permiso-title">
                <mat-icon class="permiso-option-icon">business</mat-icon>
                <strong>{{ item.cliente?.nombre }}</strong>
              </div>
              <span class="nivel-badge" [attr.data-nivel]="item.nivel">
                {{ item.nivel }}
              </span>
            </div>

            <div class="permiso-details">
              <div class="permiso-roles">
                <mat-icon class="detail-icon">person</mat-icon>
                <span>{{ item.roles.join(', ') }}</span>
              </div>

              @if (
                item.nivel === 'Grupo' &&
                item.idsGrupos &&
                item.idsGrupos.length > 0
              ) {
                <div class="permiso-scope">
                  <mat-icon class="detail-icon">folder</mat-icon>
                  <span>
                    {{ item.idsGrupos.length }} grupo{{
                      item.idsGrupos.length > 1 ? 's' : ''
                    }}
                  </span>
                </div>
              }

              @if (
                item.nivel === 'Entidad' &&
                item.idsEntidades &&
                item.idsEntidades.length > 0
              ) {
                <div class="permiso-scope">
                  <mat-icon class="detail-icon">category</mat-icon>
                  <span>
                    {{ item.tipoEntidad }}:
                    {{ item.idsEntidades.length }} entidad{{
                      item.idsEntidades.length > 1 ? 'es' : ''
                    }}
                  </span>
                </div>
              }

              @if (item.nivel === 'Cliente' && item.includeChildren) {
                <div class="permiso-scope">
                  <mat-icon class="detail-icon">account_tree</mat-icon>
                  <span>Incluye jerarquía</span>
                </div>
              }
            </div>
          </div>
        </ng-template>
      </ng-select>
    } @else {
      <div class="permiso-static">
        <mat-icon class="permiso-icon">business</mat-icon>
        <div class="permiso-info">
          <span class="permiso-cliente">
            {{ permisosEntidadesService.permisoElegido?.cliente?.nombre }}
          </span>
          <span
            class="permiso-nivel-badge"
            [attr.data-nivel]="permisosEntidadesService.permisoElegido?.nivel"
          >
            {{ permisosEntidadesService.permisoElegido?.nivel }}
          </span>
        </div>
      </div>
    }
  </div>
</section>
